export default __webpack_public_path__ + "static/media/LSO.1dbc0c46.svg";